import { BrowserRouter } from "react-router-dom";
import { RouteManager } from "src/RouteManager";
import { ThemeProvider } from "@mui/material";
import { theme } from "./MuiSetup";
function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <RouteManager />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
